export function impressionAnalytics(data) {
  return new Promise((resolve, reject) => {
    resolve(
      window.top.LIFE_CYCLE_EVENT_BUS.trigger('impression.trigger', data)
    );
  });
}
